module.exports = __webpack_public_path__ + "img/v1.2e8b0b02.png";